import React, { useMemo } from "react";
import { useParams } from "react-router-dom";
import LeftArrowTopHeader from "../../newComponents/form-fields/LeftArrowTopHeader";
import SimpleSpinner from "../../components/loader";
import LeaseAgreement from "../../components/generatePdfDocument/leaseAgreement";
import { useTenantData } from "../../tenantComponent/hooks/useTenantData";

const LeaseAgreementReviewView: React.FC = () => {
  const { id } = useParams<{ id: string }>();

  // Early validation: no ID
  if (!id) {
    return (
      <div className="review-application-container">
        <LeftArrowTopHeader title="Review Agreement" backPath={-1} />
        <div className="error-message">
          <p>No agreement ID provided.</p>
        </div>
      </div>
    );
  }

  // Parse ID once
  const agreementId = Number(id);
  if (isNaN(agreementId)) {
    return (
      <div className="review-application-container">
        <LeftArrowTopHeader title="Review Agreement" backPath={-1} />
        <div className="error-message">
          <p>Invalid agreement ID.</p>
        </div>
      </div>
    );
  }

  const { tenantData, loading: tenantLoading } = useTenantData(agreementId);

  // Calculate back path once when tenantData is available
  const backPath = useMemo(() => {
    if (tenantData?.id && tenantData?.unitId) {
      return `/tenants/currenttenantdetails/${tenantData.id}/${tenantData.unitId}`;
    }
    return -1; // Fallback to browser back if data not ready
  }, [tenantData?.id, tenantData?.unitId]);

  // String version for LeaseAgreement component
  const backPathString = typeof backPath === "string" ? backPath : undefined;

  // Show spinner while loading
  if (tenantLoading) {
    return (
      <div className="review-application-container">
        <LeftArrowTopHeader title="Review Agreement" backPath={backPath} />
        <div className="loading-container">
          <SimpleSpinner />
        </div>
      </div>
    );
  }

  // Main render when data is ready
  return (
    <div className="review-application-container content-wrapper full-page-content">
      <div className="review-content">
        <LeaseAgreement tenantData={tenantData} path={backPathString} />
      </div>
    </div>
  );
};

export default LeaseAgreementReviewView;
